/** @fileoverview Opens a link whose address the server builds, without the browser blocking the new tab. */

import { safeExternalUrl } from './helpers';

const OPEN_FAILED = "This link couldn't be opened. Please try again.";
const POPUP_BLOCKED =
  'Your browser blocked the new tab. Allow pop-ups for this site and try again.';

/** Opens an empty tab at once, then points it at the address the server returns. */
export const openServerLink = ({
  resolve,
  onError,
}: {
  resolve: () => Promise<{ url: string }>;
  onError: (message: string) => void;
}) => {
  /* The tab must open inside the click, or the browser blocks it as a pop-up. */
  const tab = window.open('', '_blank');
  if (!tab) {
    onError(POPUP_BLOCKED);
    return;
  }
  tab.opener = null;
  resolve()
    .then(({ url }) => {
      const safeUrl = safeExternalUrl(url);
      if (!safeUrl) {
        throw new Error(OPEN_FAILED);
      }
      tab.location.href = safeUrl;
    })
    .catch((error: unknown) => {
      tab.close();
      onError(error instanceof Error ? error.message : OPEN_FAILED);
    });
};
